// import React from "react";
// import { useParams } from "react-router-dom";
// import { events } from "../Data/KEvents";

// const EventDetails = () => {
//   const { id } = useParams();
//   const event = events.find((e) => e.id === parseInt(id));

//   if (!event) {
//     return <div className="p-8 text-center text-gray-500">Event not found</div>;
//   }

//   return (
//     <div className="max-w-6xl mx-auto p-6 lg:p-12 font-sans">
//       {/* Header Image */}
//       <div className="rounded-lg overflow-hidden shadow-sm">
//         <img
//           src={event.image}
//           alt={event.title}
//           className="w-full h-[280px] object-cover"
//         />
//       </div>

//       {/* Date */}
//       <p className="text-sm text-gray-500 mt-6">
//         {event.dateString || event.date}
//       </p>
//       {/* Two-column layout */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
//         <div>
//           {/* Title */}
//           <h1 className="text-2xl font-semibold text-gray-800 mt-2">
//             {event.title}
//           </h1>

//           {/* Organizer */}
//           <p className="text-sm text-gray-600 mt-1">
//             By <span className="font-medium">{event.organizer}</span>
//           </p>

//           {/* Date and Time */}
//           <div className="mt-6">
//             <h3 className="text-gray-800 font-semibold">Date and time</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.fullDate}</p>
//           </div>

//           {/* Location */}
//           <div className="mt-4">
//             <h3 className="text-gray-800 font-semibold">Location</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.location}</p>
//           </div>

//           {/* Left column - About */}
//           <div className="md:col-span-2">
//             <h3 className="text-gray-800 font-semibold mb-3">
//               About this event
//             </h3>
//             <p className="text-sm text-gray-600 leading-relaxed">
//               {event.description}
//             </p>
//           </div>
//         </div>
//         {/* Right column - Register */}
//         <div className="border border-gray-200 rounded-lg p-6 shadow-sm">
//           <h3 className="text-gray-800 font-semibold mb-4">Register Now</h3>
//           <form className="space-y-3">
//             <input
//               type="text"
//               placeholder="Enter your name"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="email"
//               placeholder="Enter your email"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="tel"
//               placeholder="Enter your phone number"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <button
//               type="button"
//               className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-md py-2 text-sm font-medium"
//             >
//               Register
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EventDetails;

// import React from "react";
// import { useParams } from "react-router-dom";
// import { events } from "../Data/KEvents";

// const EventDetails = () => {
//   const { id } = useParams();
//   const event = events.find((e) => e.id === parseInt(id));

//   if (!event) {
//     return <div className="p-8 text-center text-gray-500">Event not found</div>;
//   }

//   return (
//     <div className="max-w-6xl mx-auto p-6 lg:p-12 font-sans">
//       {/* Header Image */}
//       <div className="rounded-lg overflow-hidden shadow-sm">
//         <img
//           src={event.image}
//           alt={event.title}
//           className="w-full h-[280px] object-cover"
//         />
//       </div>

//       {/* Date */}
//       <p className="text-sm text-gray-500 mt-6">
//         {event.dateString || event.date}
//       </p>

//       {/* Content Layout */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
//         {/* LEFT: Event Information */}
//         <div className="md:col-span-2">
//           {/* Title */}
//           <h1 className="text-2xl font-semibold text-gray-800 mt-2">
//             {event.title}
//           </h1>

//           {/* Organizer */}
//           <p className="text-sm text-gray-600 mt-1">
//             By <span className="font-medium">{event.organizer}</span>
//           </p>

//           {/* Date & Time */}
//           <div className="mt-6">
//             <h3 className="text-gray-800 font-semibold">Date and time</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.fullDate}</p>
//           </div>

//           {/* Location */}
//           <div className="mt-4">
//             <h3 className="text-gray-800 font-semibold">Location</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.location}</p>
//           </div>

//           {/* About */}
//           <div className="mt-8">
//             <h3 className="text-gray-800 font-semibold mb-2">
//               About this event
//             </h3>
//             <p className="text-sm text-gray-600 leading-relaxed">
//               {event.description}
//             </p>
//           </div>

//           {/* Report Button */}
//           <button className="mt-6 text-sm text-red-500 hover:underline">
//             Report this event
//           </button>
//         </div>

//         {/* RIGHT: Register Form */}
//         <div className="border border-gray-200 rounded-lg p-6 shadow-sm h-fit">
//           <h3 className="text-gray-800 font-semibold mb-4">Register Now</h3>
//           <form className="space-y-3">
//             <input
//               type="text"
//               placeholder="Enter your name"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="email"
//               placeholder="Enter your email"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="tel"
//               placeholder="Enter your phone number"
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <button
//               type="button"
//               className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-md py-2 text-sm font-medium"
//             >
//               Register
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EventDetails;

// import React, { useState } from "react";
// import { useParams } from "react-router-dom";
// import Konn3ctHeader from "./Konn3ctHeader";
// import Footer from "./kfooter";
// import axios from "axios";
// import { events } from "../Data/KEvents";

// const EventDetails = () => {
//   const { id } = useParams();
//   const event = events.find((e) => e.id === parseInt(id));

//   // Form state
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   if (!event) {
//     return <div className="p-8 text-center text-gray-500">Event not found</div>;
//   }

//   // Handle input change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");

//     // Basic validation
//     if (!formData.name || !formData.email || !formData.phone) {
//       setMessage("Please fill out all fields before submitting.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.post("https://dev.konn3ct.ng/api/pre-registration", {
//         ref: event.ref,
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//       });

//       if (response.status === 200 || response.status === 201) {
//         setMessage("Registration successful! We'll contact you soon.");
//         setFormData({ name: "", email: "", phone: "" });
//       } else {
//         setMessage("Something went wrong. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error submitting registration:", error);
//       setMessage("Network or server error. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex flex-col text-gray-800">
//       <Konn3ctHeader />
//     <div className="max-w-6xl mx-auto p-6 lg:p-12 font-sans">

//       {/* Header Image */}
//       <div className="rounded-lg overflow-hidden shadow-sm">
//         <img
//           src={event.image}
//           alt={event.title}
//           className="w-full h-[280px] object-cover"
//         />
//       </div>

//       {/* Date */}
//       <p className="text-sm text-gray-500 mt-6">
//         {event.dateString || event.date}
//       </p>

//       {/* Layout */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
//         {/* LEFT: Event Info */}
//         <div className="md:col-span-2">
//           <h1 className="text-2xl font-semibold text-gray-800 mt-2">
//             {event.title}
//           </h1>
//           <p className="text-sm text-gray-600 mt-1">
//             By <span className="font-medium">{event.organizer}</span>
//           </p>

//           <div className="mt-6">
//             <h3 className="text-gray-800 font-semibold">Date and time</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.fullDate}</p>
//           </div>

//           <div className="mt-4">
//             <h3 className="text-gray-800 font-semibold">Location</h3>
//             <p className="text-gray-600 text-sm mt-1">{event.location}</p>
//           </div>

//           <div className="mt-8">
//             <h3 className="text-gray-800 font-semibold mb-2">
//               About this event
//             </h3>
//             <p className="text-sm text-gray-600 leading-relaxed">
//               {event.description}
//             </p>
//           </div>

//           <button className="mt-6 text-sm text-red-500 hover:underline">
//             Report this event
//           </button>
//         </div>

//         {/* RIGHT: Register Form */}
//         <div className="border border-gray-200 rounded-lg p-6 shadow-sm h-fit">
//           <h3 className="text-gray-800 font-semibold mb-4">Register Now</h3>

//           <form className="space-y-3" onSubmit={handleSubmit}>
//             <input
//               type="text"
//               name="name"
//               placeholder="Enter your name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="email"
//               name="email"
//               placeholder="Enter your email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />
//             <input
//               type="tel"
//               name="phone"
//               placeholder="Enter your phone number"
//               value={formData.phone}
//               onChange={handleChange}
//               className="w-full border border-gray-300 rounded-md p-2 text-sm"
//             />

//             <button
//               type="submit"
//               disabled={loading}
//               className={`w-full rounded-md py-2 text-sm font-medium text-white ${
//                 loading
//                   ? "bg-blue-400 cursor-not-allowed"
//                   : "bg-blue-600 hover:bg-blue-700"
//               }`}
//             >
//               {loading ? "Submitting..." : "Register"}
//             </button>
//           </form>

//           {message && (
//             <p className="text-sm mt-3 text-center text-gray-600">{message}</p>
//           )}
//         </div>
//       </div>

//     </div>
//      <Footer />
//       </div>
//   );
// };

// export default EventDetails;

// // pages/EventDetails.jsx
// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import Konn3ctHeader from "../Components/Konn3ctHeader";
// import Footer from "../Components/kfooter";
// import axios from "axios";
// import { fetchEventByRef } from "../Data/EventsApi";

// const EventDetails = () => {
//   const { ref } = useParams();
//   const [event, setEvent] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [registered, setRegistered] = useState(false);   // ← NEW STATE

//   useEffect(() => {
//     fetchEventByRef(ref).then(data => {
//       setEvent(data);
//       setLoading(false);
//     });
//   }, [ref]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitLoading(true);

//     if (!formData.name || !formData.email || !formData.phone) {
//       alert("Please fill all fields.");
//       setSubmitLoading(false);
//       return;
//     }

//     try {
//       const res = await axios.post("https://dev.konn3ct.ng/api/pre-registration", {
//         ref: event.ref,
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//       });

//       if (res.status === 200 || res.status === 201) {
//         setRegistered(true); // ← SUCCESS → HIDE FORM, SHOW TICK
//       }
//     } catch (err) {
//       alert("Registration failed. Please try again.");
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   if (loading) return <div className="p-8 text-center">Loading event...</div>;
//   if (!event) return <div className="p-8 text-center text-red-500">Event not found</div>;

//   return (
//     <div className="min-h-screen flex flex-col text-gray-800">
//       <Konn3ctHeader />
//       <div className="max-w-6xl mx-auto p-6 lg:p-12 font-sans">

//         {/* Event Image + Info (unchanged) */}
//         <div className="rounded-lg overflow-hidden shadow-sm">
//           <img src={event.image} alt={event.title} className="w-full h-[280px] object-cover" />
//         </div>

//         <p className="text-sm text-gray-500 mt-6">{event.dateString}</p>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
//           <div className="md:col-span-2">
//             <h1 className="text-2xl font-semibold text-gray-800 mt-2">{event.title}</h1>
//             <p className="text-sm text-gray-600 mt-1">By <span className="font-medium">{event.organizer}</span></p>

//             <div className="mt-6">
//               <h3 className="text-gray-800 font-semibold">Date and time</h3>
//               <p className="text-gray-600 text-sm mt-1">{event.fullDate}</p>
//             </div>

//             <div className="mt-4">
//               <h3 className="text-gray-800 font-semibold">Location</h3>
//               <p className="text-gray-600 text-sm mt-1">{event.location}</p>
//             </div>

//             <div className="mt-8">
//               <h3 className="text-gray-800 font-semibold mb-2">About this event</h3>
//               <p className="text-sm text-gray-600 leading-relaxed">{event.description}</p>
//             </div>

//            {/* Report Button */}
//            <button className="mt-6 text-sm text-red-500 hover:underline">
//              Report this event
//            </button>
//           </div>

//           {/* RIGHT SIDE — REGISTRATION */}
//           <div className="border border-gray-200 rounded-lg p-6 shadow-sm h-fit">
//             {registered ? (
//               // SUCCESS STATE — BIG TICK
//               <div className="text-center py-12">
//                 <div className="mx-auto w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
//                   <svg className="w-16 h-16 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//                   </svg>
//                 </div>
//                 <h3 className="text-2xl font-bold text-green-600">Successfully Registered!</h3>
//                 <p className="text-gray-600 mt-4">We will contact you soon with more details.</p>
//               </div>
//             ) : (
//               // NORMAL FORM
//               <>
//                 <h3 className="text-gray-800 font-semibold mb-4">Register Now</h3>
//                 <form className="space-y-3" onSubmit={handleSubmit}>
//                   <input type="text" name="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
//                   <input type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
//                   <input type="tel" name="phone" placeholder="Enter your phone number" value={formData.phone} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-2 text-sm" />
//                   <button
//                     type="submit"
//                     disabled={submitLoading}
//                     className={`w-full rounded-md py-2 text-sm font-medium text-white transition ${
//                       submitLoading ? "bg-blue-400" : "bg-[#1A4699] hover:bg-blue-700"
//                     }`}
//                   >
//                     {submitLoading ? "Submitting..." : "Register"}
//                   </button>
//                 </form>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default EventDetails;

// pages/EventDetails.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter";
import axios from "axios";
import { fetchEventByRef } from "../Events/EventsApi";
import { Helmet } from "react-helmet-async";

const EventDetails = () => {
  const { ref } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [submitLoading, setSubmitLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState(""); 

  useEffect(() => {
    if (!ref) return; 

    fetchEventByRef(ref).then((data) => {
      setEvent(data);
      setLoading(false);
    });
  }, [ref]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (submitLoading) return;

//   setSubmitLoading(true);
//   setPaymentMessage("");

//   // Basic validation
//   if (!formData.name || !formData.email || !formData.phone) {
//     alert("Please fill all fields.");
//     setSubmitLoading(false);
//     return;
//   }

//   const isPaid = (event?.free === 0);

//   // ✅ Pre-open popup window ONLY for paid events (must happen before await)
//   let payWin = null;
//   if (isPaid) {
//     const width = 520;
//     const height = 720;
//     const left = window.screenX + (window.outerWidth - width) / 2;
//     const top = window.screenY + (window.outerHeight - height) / 2;

//     const features = `
//       width=${width},
//       height=${height},
//       left=${left},
//       top=${top},
//       resizable=yes,
//       scrollbars=yes,
//       toolbar=no,
//       menubar=no,
//       location=no,
//       status=no
//     `.replace(/\s+/g, "");

//     // Use a named window to encourage popup behavior
//     payWin = window.open("about:blank", "Konn3ctPaymentWindow", features);

//     // If popup is blocked immediately, we can still proceed but must show a link later
//     if (payWin && payWin.document) {
//       payWin.document.write(
//         "<p style='font-family:sans-serif;padding:16px'>Loading payment page…</p>"
//       );
//     }
//   }

//   try {
//     const eventRef = event?.ref || ref;
//     if (!eventRef) throw new Error("Event reference missing");

//     // Build payload
//     const payload = {
//       ref: eventRef,
//       name: formData.name.trim(),
//       email: formData.email.trim(),
//       phone: formData.phone.trim(),
//     };

//     // Optional: only add txn ref if your backend expects it
//     if (isPaid) {
//       const base = eventRef; // avoid event.ref (might be undefined)
//       const txnRef = `KONN-${base}-${Date.now()}-${Math.random()
//         .toString(36)
//         .slice(-6)
//         .toUpperCase()}`;

//       payload.reference = txnRef; // keep only if backend uses it
//     }

//     console.log("Sending payload:", payload);

//     const res = await axios.post(
//       "https://konn3ct.com/api/pre-registration",
//       payload,
//       { headers: { "Content-Type": "application/json" } }
//     );
    
//     console.log("Backend response:", res.data);

//     const responseData = res.data;

//     if (!responseData?.success) {
//       throw new Error(responseData?.message || "Registration failed");
//     }

//     // ✅ Registration successful (for both free & paid)
//     setRegistered(true);

//     // Paid: proceed to payment
//     if (isPaid) {
//       const paymentUrl = responseData?.data;

//       if (!paymentUrl || typeof paymentUrl !== "string" || !/^https?:\/\//i.test(paymentUrl)) {
//         throw new Error("Missing or invalid payment URL from server");
//       }

//       console.log("Payment URL:", paymentUrl);

//       // Best effort: use pre-opened popup
//       if (payWin && !payWin.closed) {
//         payWin.location.href = paymentUrl;
//         setPaymentMessage("Payment window opened. Please complete the payment there.");
//       } else {
//         // Popup blocked -> show user a click link (guaranteed user gesture)
//         setPaymentMessage(
//           <span>
//             Popup blocked.{" "}
//             <a
//               href={paymentUrl}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-blue-600 underline font-medium"
//             >
//               Click here to open payment window
//             </a>
//           </span>
//         );
//       }

//       return;
//     }

//     // Free event success message (optional)
//     setPaymentMessage("Registration successful.");
//   } catch (err) {
//     // If we opened a blank window, close it on error
//     if (payWin && !payWin.closed) payWin.close();

//     console.error("Registration error:", err);
//     const msg =
//       err?.response?.data?.message ||
//       err?.message ||
//       "Registration failed. Please try again.";

//     alert(msg);
//     setPaymentMessage(<span className="text-red-600">{msg}</span>);
//   } finally {
//     setSubmitLoading(false);
//   }
// };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (submitLoading) return; 

  setSubmitLoading(true);
  setPaymentMessage("");

  if (!formData.name || !formData.email || !formData.phone) {
    alert("Please fill all fields.");
    setSubmitLoading(false);
    return;
  }

  const isPaid = event?.free === 0;

  let payWin = null;
  if (isPaid) {
    const width = 520;
    const height = 720;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`;

    payWin = window.open("about:blank", "Konn3ctPayment", features);

    if (payWin && payWin.document) {
      payWin.document.write("<p style='font-family:sans-serif;padding:16px'>Preparing payment page...</p>");
    }
  }

  try {
    const eventRef = event?.ref || ref;
    if (!eventRef) throw new Error("Event reference missing");

    const payload = {
      ref: eventRef,
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
    };

    if (isPaid) {
      const base = eventRef;
      const txnRef = `KONN-${base}-${Date.now()}-${Math.random().toString(36).slice(-6).toUpperCase()}`;
      payload.reference = txnRef;
    }

    console.log("Submitting payload:", payload);

    const res = await axios.post(
      "https://konn3ct.com/api/pre-registration",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    console.log("Backend response:", res.data);

    const responseData = res.data;

    if (!responseData?.success) {
      const errMsg = responseData?.message || "Registration failed";
      alert(errMsg);
      setPaymentMessage(<span className="text-red-600">{errMsg}</span>);

      if (payWin && !payWin.closed) payWin.close();
      return;
    }

    // Success: Pre-registration done
    if (!isPaid) {
      // Free event: Show success immediately
      setRegistered(true);
      setPaymentMessage("Registration successful – you're all set!");
    } else {
      // Paid event: Do NOT set registered yet
      const paymentUrl = responseData?.data;

      if (!paymentUrl || typeof paymentUrl !== "string" || !/^https?:\/\//i.test(paymentUrl)) {
        throw new Error("Invalid or missing payment URL from server");
      }

      console.log("Payment URL:", paymentUrl);

      if (payWin && !payWin.closed) {
        payWin.location.href = paymentUrl;
        setPaymentMessage(
          <span className="text-green-600">
            Pre-registration complete! Payment window opened – please complete payment there to finalize.
          </span>
        );
      } else {
        setPaymentMessage(
          <span className="text-amber-600">
            Pre-registration done, but payment popup blocked.{" "}
            <a
              href={paymentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline font-medium hover:text-blue-800"
            >
              Click here to complete payment
            </a>
          </span>
        );
      }

      // Optional: Suggest refresh after payment
      setPaymentMessage((prev) => (
        <>
          {prev}
          <br />
          <small className="text-gray-500">
            After successful payment, refresh this page or check your email for confirmation.
          </small>
        </>
      ));
    }
  } catch (err) {
    if (payWin && !payWin.closed) payWin.close();

    console.error("Error:", err);

    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "An error occurred. Please try again.";

    alert(msg);
    setPaymentMessage(<span className="text-red-600">{msg}</span>);
  } finally {
    setSubmitLoading(false);
  }
};

  if (loading) return <div className="p-8 text-center">Loading event...</div>;
  if (!event)
    return <div className="p-8 text-center text-red-500">Event not found</div>;

  const isPaid = event.free === 0;

  return (
    <div className="min-h-screen flex flex-col text-gray-800 pt-24">
            {/* <div className="min-h-screen px-6 lg:px-16 py-10 pt-24 font-sans bg-white"> */}

<Helmet>
      <title>{event.title} | Konn3ct</title>

      <meta
        name="description"
        content={event.description?.slice(0, 160)}
      />

      {/* Open Graph */}
      <meta property="og:title" content={event.title} />
      <meta
        property="og:description"
        content={event.description?.slice(0, 160)}
      />
      <meta property="og:image" content={event.logo} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={event.title} />
      <meta
        name="twitter:description"
        content={event.description?.slice(0, 160)}
      />
      <meta name="twitter:image" content={event.logo} />
    </Helmet>


      <Konn3ctHeader />
      <div className="min-h-screen max-w-6xl mx-auto p-6 lg:p-12 pt-24 font-sans">
        {/* Event Image */}
        <div className="rounded-lg overflow-hidden shadow-sm">
          <img
            src={event.logo}
            alt={event.title}
            className="w-full h-[280px] object-cover"
          />
        </div>

        <p className="text-sm text-gray-500 mt-6">{event.dateString}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
          {/* Left: Event Info */}
          <div className="md:col-span-2">
            <h1 className="text-2xl font-semibold text-gray-800 mt-2">
              {event.title}
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              By <span className="font-medium">{event.organizer}</span>
            </p>

            <div className="mt-6">
              <h3 className="text-gray-800 font-semibold">Date and time</h3>
              <p className="text-gray-600 text-sm mt-1">{event.fullDate}</p>
            </div>

            <div className="mt-4">
              <h3 className="text-gray-800 font-semibold">Location</h3>
              <p className="text-gray-600 text-sm mt-1">{event.location}</p>

              <div className="mt-4">
                <h3 className="text-gray-800 font-semibold">Price</h3>
                <p className="text-gray-600 text-sm mt-1">
                  {event.free === 1
                    ? "FREE"
                    : `₦${Number(event.amount || 0).toLocaleString()}`}{" "}
                </p>
              </div>
            </div>

            <div className="mt-8">
              <h3 className="text-gray-800 font-semibold mb-2">
                About this event
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {event.description}
              </p>
            </div>

            <button className="mt-6 text-sm text-red-500 hover:underline">
              Report this event
            </button>
          </div>

          {/* Right: Registration Section */}
          <div className="border border-gray-200 rounded-lg p-6 shadow-sm h-fit">
            {registered ? (
              // Success Tick (unchanged)
              <div className="text-center py-12">
                <div className="mx-auto w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <svg
                    className="w-16 h-16 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-green-600">
                  Successfully Registered!
                </h3>
                <p className="text-gray-600 mt-4">
                  We will contact you soon with more details.
                </p>
              </div>
            ) : (
              // Form with Paid/Free logic
              <>
                <h3 className="text-gray-800 font-semibold mb-4">
                  {isPaid ? "Pay & Register now" : "Register Now"}
                </h3>

                {paymentMessage && (
                  <p className="text-blue-600 text-sm mb-4 font-medium">
                    {paymentMessage}
                  </p>
                )}

                <form className="space-y-3" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  />

                  <button
                    type="submit"
                    disabled={submitLoading}
                    className={`w-full rounded-md py-2 text-sm font-medium text-white transition ${
                      submitLoading
                        ? "bg-blue-400"
                        : "bg-[#1A4699] hover:bg-blue-700"
                    }`}
                  >
                    {submitLoading
                      ? "Submitting..."
                      : isPaid
                      ? "Pay to Register"
                      : "Register"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EventDetails;
